/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetShardRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {GetShardResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const privacyVaultGetShard = (request:GetShardRequest, options?: CashRequestOptions) => post<GetShardRequest, GetShardResponse>("/2.0/cash/privacy-vault-get-shard", request, {...options, rejectOnError: true })